export default ({ item, location }) => `${item.id}_${location.id}`;
